export default "__VITE_ASSET__5f823fce__$_?component__"